module.exports = __webpack_public_path__ + "img/add_object.95abb23f.png";